/**
 * One-use boosts (bought in the shop, fired from the HUD): each runs for a few seconds, and each
 * kind can be used once per attempt.
 */
export type BoostId = 'shield' | 'turbo' | 'magnet' | 'treat';
export const BOOST_IDS: readonly BoostId[] = ['shield', 'turbo', 'magnet', 'treat'];

/** How long each boost lasts, in ticks (60 per second). */
export const BOOST_TICKS: Readonly<Record<BoostId, number>> = {
  /** Bumps cost no heart. */
  shield: 180,
  /** A burst of speed. */
  turbo: 120,
  /** Coins nearby fly to the mower. */
  magnet: 300,
  /** Critters stop to munch and stay put. */
  treat: 600,
};

/** Turbo multiplies the time to cross a tile by this ratio. */
export const TURBO_SPEED = { num: 3, den: 5 } as const;
/** The coin magnet's reach, in tiles (all round the mower; owner, 2026-10-10: wider than 2). */
export const MAGNET_REACH = 3;

export const isBoostId = (value: unknown): value is BoostId =>
  typeof value === 'string' && (BOOST_IDS as readonly string[]).includes(value);
